import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const RefrigeratorIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "RefrigeratorIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M17.9838 11.2002H6.7362C6.39115 11.2002 6.11133 10.9204 6.11133 10.5753V3.7018C6.11133 3.01257 6.67184 2.45207 7.36106 2.45207H17.3589C18.0482 2.45207 18.6087 3.01258 18.6087 3.7018V10.5753C18.6087 10.9204 18.3289 11.2002 17.9838 11.2002ZM7.36108 9.95048H17.359V3.7018H7.36107L7.36108 9.95048Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.3589 21.1987H7.36106C6.67183 21.1987 6.11133 20.6382 6.11133 19.949V10.5753C6.11133 10.2303 6.39115 9.9511 6.7362 9.9511H17.9838C18.3289 9.9511 18.6087 10.2303 18.6087 10.5753L18.6087 19.949C18.6087 20.6382 18.0482 21.1987 17.3589 21.1987ZM7.36106 11.2008V19.949H17.3599L17.3589 11.2008H7.36106Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.98571 22.4476C7.64066 22.4476 7.36084 22.1678 7.36084 21.8228V20.573C7.36084 20.228 7.64066 19.9482 7.98571 19.9482C8.33076 19.9482 8.61058 20.228 8.61058 20.573V21.8228C8.61058 22.1678 8.33076 22.4476 7.98571 22.4476Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.7338 22.4476C16.3887 22.4476 16.1089 22.1678 16.1089 21.8228V20.573C16.1089 20.228 16.3887 19.9482 16.7338 19.9482C17.0788 19.9482 17.3586 20.228 17.3586 20.573V21.8228C17.3586 22.1678 17.0788 22.4476 16.7338 22.4476Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.23571 8.70128C8.89066 8.70128 8.61084 8.42146 8.61084 8.07641V5.57694C8.61084 5.23189 8.89066 4.95207 9.23571 4.95207C9.58076 4.95207 9.86058 5.23189 9.86058 5.57694V8.07641C9.86058 8.42146 9.58076 8.70128 9.23571 8.70128Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.23571 17.4491C8.89066 17.4491 8.61084 17.1692 8.61084 16.8242V13.075C8.61084 12.7299 8.89066 12.4501 9.23571 12.4501C9.58076 12.4501 9.86058 12.7299 9.86058 13.075V16.8242C9.86058 17.1692 9.58076 17.4491 9.23571 17.4491Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default RefrigeratorIcon;
